if (!customElements.get('ly-buyer-showcase-gallery')) {
    customElements.define('ly-buyer-showcase-gallery', class extends HTMLElement {
        currentIndex = 0
        touchStart = null

        connectedCallback() {
            this.slides = [...this.querySelectorAll('[data-gallery-image]')]
            this.counter = this.querySelector('[data-gallery-counter]')
            this.prevButton = this.querySelector('[data-gallery-prev]')
            this.nextButton = this.querySelector('[data-gallery-next]')

            if (!this.slides.length) return

            if (this.slides.length < 2) {
                this.prevButton?.setAttribute('hidden', '')
                this.nextButton?.setAttribute('hidden', '')
                this.counter?.setAttribute('hidden', '')
                return
            }

            const activeIndex = this.slides.findIndex(slide => slide.classList.contains('is-active'))
            this.currentIndex = activeIndex < 0 ? 0 : activeIndex

            this.addEventListener('click', this.handleClick)
            this.addEventListener('touchstart', this.handleTouchStart, { passive: true })
            this.addEventListener('touchmove', this.handleTouchMove, { passive: false })
            this.addEventListener('touchend', this.handleTouchEnd, { passive: true })
            this.addEventListener('touchcancel', this.handleTouchCancel)

            this.select(this.currentIndex, { animate: false })
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleClick)
            this.removeEventListener('touchstart', this.handleTouchStart)
            this.removeEventListener('touchmove', this.handleTouchMove)
            this.removeEventListener('touchend', this.handleTouchEnd)
            this.removeEventListener('touchcancel', this.handleTouchCancel)
        }

        handleClick = (event) => {
            const prevButton = event.target.closest('[data-gallery-prev]')
            if (prevButton && this.contains(prevButton)) {
                this.select(this.currentIndex - 1)
                return
            }

            const nextButton = event.target.closest('[data-gallery-next]')
            if (nextButton && this.contains(nextButton)) {
                this.select(this.currentIndex + 1)
            }
        }

        handleTouchStart = (event) => {
            const touch = event.touches[0]
            this.touchStart = { x: touch.clientX, y: touch.clientY }
        }

        handleTouchMove = (event) => {
            if (!this.touchStart) return

            const touch = event.touches[0]
            const distanceX = touch.clientX - this.touchStart.x
            const distanceY = touch.clientY - this.touchStart.y

            if (Math.abs(distanceX) > 8 && Math.abs(distanceX) > Math.abs(distanceY)) {
                event.preventDefault()
            }
        }

        handleTouchCancel = () => {
            this.touchStart = null
        }

        handleTouchEnd = (event) => {
            if (!this.touchStart) return

            const touch = event.changedTouches[0]
            const distanceX = touch.clientX - this.touchStart.x
            const distanceY = touch.clientY - this.touchStart.y

            if (Math.abs(distanceX) > 50 && Math.abs(distanceX) > Math.abs(distanceY) * 1.25) {
                this.select(this.currentIndex + (distanceX < 0 ? 1 : -1))
            }

            this.touchStart = null
        }

        select(index, { animate = true } = {}) {
            const length = this.slides.length
            if (!length) return

            this.currentIndex = (index + length) % length

            this.slides.forEach((slide, slideIndex) => {
                slide.classList.toggle('is-active', slideIndex === this.currentIndex)
            })

            if (this.counter) {
                this.counter.textContent = `${this.currentIndex + 1} / ${length}`
            }
        }
    })
}

if (!window.__lyBuyerShowcaseScrollBound) {
    window.__lyBuyerShowcaseScrollBound = true

    document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-buyer-scroll]')
        if (!button) return

        const section = button.closest('.ly-buyer-showcase-section-container')
        if (!section) return

        const mobileTarget = Number(section.dataset.scrollTopMobile || 0)
        const desktopTarget = Number(section.dataset.scrollTopDesktop || mobileTarget)
        const top = window.matchMedia('(max-width: 767px)').matches ? mobileTarget : desktopTarget

        window.scrollTo({ top, behavior: 'smooth' })
    })
}
